import React from "react";
import { ArrowDown, ArrowUp, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/**
 * Master v5 Prompt 30C Phase 2 — `list` input type editor. Value is a
 * real structured array `[{id, text}]` — never a newline-encoded string.
 */
export function ListInputEditor({ value, onChange, disabled, testId }) {
  const items = value || [];

  const update = (next) => onChange(next);
  const setItemText = (id, text) => update(items.map((it) => (it.id === id ? { ...it, text } : it)));
  const removeItem = (id) => update(items.filter((it) => it.id !== id));
  const addItem = () => update([...items, { id: `item_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`, text: "" }]);
  const move = (index, direction) => {
    const next = [...items];
    const target = index + direction;
    if (target < 0 || target >= next.length) return;
    [next[index], next[target]] = [next[target], next[index]];
    update(next);
  };

  return (
    <div className="space-y-2" data-testid={testId || "list-input-editor"}>
      {items.map((item, i) => (
        <div key={item.id} className="flex items-center gap-2" data-testid={`list-input-item-${i}`}>
          <div className="flex flex-col">
            <button type="button" disabled={disabled || i === 0} onClick={() => move(i, -1)} className="text-muted-foreground hover:text-foreground disabled:opacity-30" data-testid={`list-input-item-${i}-up`}>
              <ArrowUp className="h-3 w-3" />
            </button>
            <button type="button" disabled={disabled || i === items.length - 1} onClick={() => move(i, 1)} className="text-muted-foreground hover:text-foreground disabled:opacity-30" data-testid={`list-input-item-${i}-down`}>
              <ArrowDown className="h-3 w-3" />
            </button>
          </div>
          <Input value={item.text} disabled={disabled} onChange={(e) => setItemText(item.id, e.target.value)} placeholder={`Item ${i + 1}`} data-testid={`list-input-item-${i}-text`} />
          <Button type="button" variant="ghost" size="sm" disabled={disabled} onClick={() => removeItem(item.id)} data-testid={`list-input-item-${i}-remove`}>
            <Trash2 className="h-4 w-4 text-muted-foreground" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" disabled={disabled} onClick={addItem} data-testid="list-input-add-item-btn">
        <Plus className="h-3.5 w-3.5 mr-1" /> Add item
      </Button>
    </div>
  );
}
